import React from 'react';
import LabEmptyState from './LabEmptyState';

export default function LabTable({ columns, rows, emptyTitle = 'No data available', emptyDescription = 'This view has nothing to show yet.' }) {
  if (!rows?.length) {
    return <LabEmptyState title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <div className="lab-table-wrap">
      <table className="lab-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id || row.serialNumber || row.stationName || row.stepName || rowIndex}>
              {columns.map((column) => (
                <td key={column.key}>
                  {typeof column.render === 'function' ? column.render(row[column.key], row) : row[column.key] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
